import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'src/routes';
import { Box } from 'src/shared/components/Box';
import { Button } from 'src/shared/components/Button';
import { Icon } from 'src/shared/components/Icon';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from 'src/shared/components/Modal';
import { routes } from '../routes';

export interface SubmitVideoModalProps extends ModalProps {}

export const SubmitVideoModal = ({
  onClose,
  ...otherProps
}: SubmitVideoModalProps) => {
  const history = useHistory();

  const { t } = useTranslation('features.bestOfRing');
  return (
    <Modal {...otherProps} onClose={onClose} isCentered size="xlg">
      <ModalOverlay>
        <ModalContent p={0}>
          <ModalHeader justifyContent="center" width={1}>
            {t('submit-your-video')}
          </ModalHeader>
          <ModalCloseButton color="neutral.500" />
          <ModalBody py={24} px={40} textAlign="left">
            <Box mb={2}>
              <Icon name="submit_video" color="primary.500" size={40} mr={1} />
            </Box>
            <Box
              textStyle={{
                _: 'heading-small-medium',
                m: 'heading-normal-medium',
              }}
              mb={2}
            >
              {t('submit-your-video')}
            </Box>
            <Box textStyle="body-large-light" whiteSpace="pre-wrap">
              {t('submit-video-modal.description')}
            </Box>
          </ModalBody>
          <ModalFooter borderTopWidth={0} px={40} pb={24} pt={{ _: 4, m: 16 }}>
            <Button
              size="lg"
              variant="outline-primary"
              mr={{ _: 0, m: 4 }}
              mb={{ _: 3, m: 0 }}
              width={{ _: 1, m: 1 / 2 }}
              display={{ _: 'none', m: 'block' }}
              onClick={onClose}
            >
              {t('submit-video-modal.cancel-button')}
            </Button>
            <Button
              onClick={() =>
                history.push(AppRoutes.BestOfRing + routes.RingHistory)
              }
              size="lg"
              variant="primary"
              width={{ _: 1, m: 1 / 2 }}
            >
              {t('submit-video-modal.select-video-button')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};
